import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/arrow_left.svg'
import _imports_1 from '@/assets/img/motoguzzi_logo.png'


const _hoisted_1 = { class: "onboarding login" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "sideContainer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "motoGuzziLogo"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "bg_grey mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "gigya-login-one-column" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "squareButton bg_black",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          }, _hoisted_6)
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      _hoisted_9
    ])
  ]))
}